import { render, staticRenderFns } from "./OffersList.vue?vue&type=template&id=131e7875&scoped=true&"
import script from "./OffersList.vue?vue&type=script&lang=js&"
export * from "./OffersList.vue?vue&type=script&lang=js&"
import style0 from "./OffersList.vue?vue&type=style&index=0&id=131e7875&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e7875",
  null
  
)

export default component.exports